import katex from 'katex'

type BlockMathProps = {
    math: string
}

export function BlockMath({ math }: BlockMathProps) {
    return (
        <span
            dangerouslySetInnerHTML={{
                __html: katex.renderToString(math, {
                    throwOnError: false,
                    displayMode: true,
                }),
            }}
        />
    )
}
